var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container bj-label-colon" },
    [
      _c(
        "BjDivider",
        [
          _vm._v("基础信息 "),
          _c(
            "template",
            { slot: "right" },
            [
              !_vm.isView
                ? [
                    _c("el-button", { on: { click: _vm.tryCancel } }, [
                      _vm._v(_vm._s(_vm.$t("cancelText"))),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.handleConfirm("form")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("okText")))]
                    ),
                  ]
                : _vm._e(),
              _vm.isView
                ? _c("el-button", { on: { click: _vm.cancel } }, [
                    _vm._v(_vm._s(_vm.$t("backText"))),
                  ])
                : _vm._e(),
              _vm.isView && _vm.$route.query.isVerify
                ? [
                    _vm.info.status == "wait"
                      ? _c(
                          "el-button",
                          {
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.onStatus("pass", _vm.info)
                              },
                            },
                          },
                          [_vm._v("审核通过")]
                        )
                      : _vm._e(),
                    _vm.info.status == "wait"
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.onStatus("reject", _vm.info)
                              },
                            },
                          },
                          [_vm._v("审核拒绝")]
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "gray",
          staticStyle: { width: "600px" },
          attrs: { model: _vm.form, "label-width": "130px", rules: _vm.rules },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "调拨单号", prop: "code" } },
                    [
                      _c("BjInputCode", {
                        attrs: { disabled: _vm.isView },
                        model: {
                          value: _vm.form.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "code", $$v)
                          },
                          expression: "form.code",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "移出逻辑仓",
                        prop: "supportWarehouseId",
                      },
                    },
                    [
                      _c("BjSelectWarehouse", {
                        attrs: { disabled: _vm.isView, "type-code": ["logic"] },
                        on: { change: _vm.getSupport },
                        model: {
                          value: _vm.form.supportWarehouseId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "supportWarehouseId", $$v)
                          },
                          expression: "form.supportWarehouseId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "移入逻辑仓",
                        prop: "receiveWarehouseId",
                      },
                    },
                    [
                      _c("BjSelectWarehouse", {
                        attrs: { disabled: _vm.isView, "type-code": ["logic"] },
                        on: { change: _vm.getReceive },
                        model: {
                          value: _vm.form.receiveWarehouseId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "receiveWarehouseId", $$v)
                          },
                          expression: "form.receiveWarehouseId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.remarkText"),
                        prop: "remark",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          disabled: _vm.isView,
                          type: "textarea",
                          "show-word-limit": "",
                          autosize: { minRows: 2, maxRows: 4 },
                          placeholder: _vm.$t("inputText"),
                        },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u(
            [
              !_vm.isView
                ? {
                    key: "button",
                    fn: function () {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "xs",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.dialogListGoodsShow()
                              },
                            },
                          },
                          [_vm._v("添加商品")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "xs",
                            attrs: {
                              disabled: _vm.selectedRow.length == 0,
                              type: "primary",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onDelSelected()
                              },
                            },
                          },
                          [_vm._v("删除商品")]
                        ),
                      ]
                    },
                    proxy: true,
                  }
                : null,
            ],
            null,
            true
          ),
        },
        [_vm._v("商品明细 ")]
      ),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: {
            data: _vm.form.detailList,
            stripe: "",
            border: "",
            "header-cell-style": _vm.$rowStyle.DEFAULT,
            "row-key": "BJ_EBC_ID",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          !_vm.isView
            ? _c("el-table-column", {
                attrs: { type: "selection", width: "55", align: "center" },
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              type: "index",
              width: "55",
              align: "center",
              label: "序号",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "spuName", label: "商品名称", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "spuCode",
              label: "商品编码",
              align: "center",
              width: "160",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "skuName", label: "SKU名称", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "skuCode",
              label: "SKU编码",
              align: "center",
              width: "160",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "outStockNum",
              label: "移出逻辑仓在库库存",
              align: "center",
              width: "90",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "outStockUsableNum",
              label: "可调拨数量",
              align: "center",
              width: "90",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "inStockNum",
              label: "移入逻辑仓在库库存",
              align: "center",
              width: "90",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "inStockUsableNum",
              label: "移入逻辑仓可用库存",
              align: "center",
              width: "90",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "planNum",
              label: "调拨数量",
              align: "center",
              width: "90",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("BjInputNumber", {
                      attrs: {
                        disabled: _vm.isView,
                        max: props.row.outStockUsableNum,
                      },
                      model: {
                        value: props.row.planNum,
                        callback: function ($$v) {
                          _vm.$set(props.row, "planNum", $$v)
                        },
                        expression: "props.row.planNum",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "delete-btn",
                        attrs: { type: "text", disabled: _vm.isView },
                        on: {
                          click: function ($event) {
                            return _vm.onDelete(props.row, props.$index)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("delText")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("BjDialogList", {
        ref: "dialogListGoods",
        attrs: {
          config: _vm.dialogListConfigGoods,
          "row-keys": "skuCode",
          multiple: "",
        },
        on: { confirm: _vm.onConfirmDialogListGoods },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }